import VueStringFilter from 'vue-string-filter'
import Vue from 'vue'

Vue.use(VueStringFilter);